<div class="container-fluid px-4 mt-4 mb-5" *ngIf="isActive">
    <div class="cp-page-header mb-4">
        <div class="cp-page-title"><i class="fa-solid fa-door-open me-2"></i>Control de ingreso</div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Inicio</a></li>
                <li class="breadcrumb-item active">Control de ingreso</li>
            </ol>
        </nav>
    </div>

    <div class="row g-3">
            <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="card cp-module-card" routerLink="dependencias/gestion">
                    <div class="cp-module-icon"><i class="fa-solid fa-building fa-3x"></i></div>
                    <div class="cp-module-title">Dependencias</div>
                    <div class="cp-module-desc">Nuevos clientes, administración</div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="card cp-module-card" routerLink="registro">
                    <div class="cp-module-icon"><i class="fa-solid fa-person-military-pointing fa-3x"></i></div>
                    <div class="cp-module-title">Controles</div>
                    <div class="cp-module-desc">Colaboradores, perfil de usuario</div>
                </div>
            </div>
    </div>
</div>
<router-outlet></router-outlet>
